var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-only',{scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('TechLinksSkeleton')]},proxy:true}])},[_vm._v(" "),_c('TechLinks',{attrs:{"conf-data":_vm.ATG_BE_CONF}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }